export default {
  'get-list': {
    method: 'post',
    url: '/client/vehicle/list'
  },
  all: {
    method: 'post',
    url: '/client/vehicle/all'
  },
  getById: {
    method: 'get',
    url: '/client/vehicle/ID'
  },
  delete: {
    method: 'delete',
    url: '/client/vehicle'
  },
  add: {
    method: 'post',
    url: '/client/vehicle'
  },
  edit: {
    method: 'put',
    url: '/client/vehicle/ID'
  },
  select: {
    method: 'get',
    url: '/client/vehicle/find'
  },
  changeStatus: {
    method: 'post',
    url: '/client/vehicle/change-status'
  },
  archive: {
    method: 'delete',
    url: '/client/vehicle/archive'
  },
  restore: {
    method: 'put',
    url: '/client/vehicle/restore'
  },
  archiveDocument: {
    method: 'delete',
    url: '/client/vehicle/document/archive'
  },
  restoreDocument: {
    method: 'put',
    url: '/client/vehicle/document/restore'
  },
  archivePlugin: {
    method: 'delete',
    url: '/client/vehicle/plugin/archive'
  },
  restorePlugin: {
    method: 'put',
    url: '/client/vehicle/plugin/restore'
  },
  stopExploit: {
    method: 'put',
    url: '/client/vehicle/ID/stop-exploit'
  },
  openExploit: {
    method: 'put',
    url: '/client/vehicle/ID/open-exploit'
  },
  getGPS: {
    method: 'get',
    url: '/client/vehicle/gps/ID'
  },
  getGPSAll: {
    method: 'get',
    url: '/client/vehicle/gps/all'
  }
}
